import React from 'react';
import PropTypes from 'prop-types';

import { Flexer, Text } from '@ontruck/orc';

import { StyledAlert, StyledLoadingContainer, StyledLoading } from './styled';

const Alert = ({
  title,
  subtitle,
  actionChildren,
  loading,
  timeOfCreation,
  changing,
  ...props
}) => (
  <StyledAlert flexDirection="column" {...props}>
    <Flexer.Child flex="1">
      <Text display="block" weight="bold" color="grey900">
        {title}
      </Text>
      {!!subtitle && <Text color="grey700">{subtitle}</Text>}
    </Flexer.Child>
    <StyledLoadingContainer mTop="S" loading={changing}>
      {changing && <StyledLoading />}
      {!changing && actionChildren}
    </StyledLoadingContainer>
  </StyledAlert>
);

Alert.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  actionChildren: PropTypes.any,
  loading: PropTypes.bool.isRequired,
  timeOfCreation: PropTypes.string,
  changing: PropTypes.bool,
};

export default Alert;
